/*



*/
import { useState, useEffect, createRef } from "react";
// Renders hidden push to target
import MediaPush from "./MediaPush/MediaPush";
// Renders hidden canvas processing element
import MediaProcess from "./MediaProcess/MediaProcess";
// Renders swipe-able preview of available streams to push/view/edit
import MediaCarousel from "./MediaCarousel/MediaCarousel";
// Renders a MediaStream preview
import MediaStreamPreview from "./MediaStreamPreview";
import "./style.css";

const StreamCrafter = (props) => {
  // List of all available MediaStreams to push
  const [mediaStreams, setStreams] = useState([]);
  // List of all active pushes
  const [activePushes, setPushes] = useState([]);
  // Current active stream to edit/view
  const [currentStream, setCurrentSteam] = useState(null);

  // Stop all media tracks when this component gets destroyed
  useEffect(() => {
    return () => {
      mediaStreams.map((inputObj) =>
        inputObj.mediaSourceRef?.current?.getTracks().forEach(function (track) {
          track.stop();
        })
      );
    };
  }, []);

  // Create a new raw input (video) MediaStream and append it to the state
  const addMediaStream = (newObj) => {
    setStreams([...mediaStreams, newObj]);
  };

  // Remove the MediaStream with the given index from the state
  const removeStream = (mediaIndex) => {
    if (mediaIndex >= mediaStreams.length) {
      return;
    }
    removeBroadcast(mediaStreams[mediaIndex]);
    if (mediaStreams[mediaIndex] == currentStream) {
      clearPreview();
    }
    mediaStreams[mediaIndex].mediaSourceRef?.current
      ?.getTracks()
      .forEach(function (track) {
        track.stop();
      });
    setStreams((oldValues) => {
      return oldValues.filter((_, i) => i !== mediaIndex);
    });
  };

  // Clears currentStream
  const clearPreview = () => {
    setCurrentSteam(null);
  };

  // Starts a push for the given MediaStream
  const startBroadcast = (streamObj, type, target) => {
    setPushes([
      ...activePushes,
      {
        mediaSourceRef: streamObj.mediaSourceRef,
        type: type,
        active: true,
        target: target,
      },
    ]);
  };

  // Stops the first found push for the given MediaStream
  const removeBroadcast = (streamObj) => {
    for (var index = 0; index < activePushes.length; index++) {
      const obj = activePushes[index];
      if (obj.mediaSourceRef.current == streamObj.mediaSourceRef.current) {
        setPushes((oldValues) => {
          return oldValues.filter((_, i) => i !== index);
        });
        break;
      }
    }
  };

  return (
    <div
      className="row-container noselect"
      style={{
        width: "100%",
        heigh: "100%"
      }}
    >
      <div className="column-container flex-grow">
        {/* Render main screen */}
        <div className="column-container flex-grow">
          <div className="row-container">
            {/* Render preview window */}
              <MediaStreamPreview
                stream={currentStream?.mediaSourceRef?.current}
                styleOverride={{
                  height: "100%",
                  maxHeight: "calc(100vh - 24em)",
                  width: "100%",
                  maxWidth: "calc(100vw - 2em)",
                  alignSelf: "center",
                  flex: "1",
                }}
              />
            {/* Render carousel of MediaStreams */}
            <div
              className="frosty"
              style={{
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
                width: "100%",
                position: "absolute",
                borderTop: "1px solid #000",
                minHeight: "200px",
                bottom: "0",
                left: "0"
              }}
            >
              <MediaCarousel
                // Functions to add new MediaStreams
                addMediaStream={addMediaStream}
                // Used to show which MediaButton is currently maximized
                currentStream={currentStream}
                // All media streams we want to render a preview for
                mediaStreams={mediaStreams}
                // Setters for the state
                removeStream={removeStream}
                clearPreview={clearPreview}
                startBroadcast={startBroadcast}
                removeBroadcast={removeBroadcast}
                setCurrentSteam={setCurrentSteam}
                // Amount of items shown in the carousel
                carouselItems={props.carouselItems}
                // Amount of pushes currently active
                // NOTE: we need to actually check the 'active' value in the future
                isAtLimit={activePushes.length >= (props.maxPushes || 99)}
                // In order to show a start/stop broadcast button
                activePushes={activePushes}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Render active exports or Broadcasts */}
      {activePushes.map((obj, i) => {
        return (
          <MediaPush
            broadcastObj={obj}
            key={"broadcast-" + obj.type + "-" + i}
            targetOverride={props.targetOverride}
          />
        );
      })}
      {/* Render hidden canvas for processing */}
      {mediaStreams.map((mediaStream, i) => {
        return (
          <MediaProcess
            mediaStream={mediaStream}
            mediaStreams={mediaStreams}
            key={"canvas-render-" + i}
          />
        );
      })}
    </div>
  );
};

export default StreamCrafter;
